(() => {
    if (!customElements.get("back-to-top")) {
      class BackToTop extends HTMLElement {
        constructor() {
          super();
          
        }

        connectedCallback() {
            this.checkScroll();
            this.addEventListener('click', this.scrollToTop)

        }
  
        checkScroll() {
            if (document.documentElement.scrollTop > 100) {
                this.style.display = "block";
            } else {
                this.style.display = "none";
            }

            window.addEventListener('scroll', () => {
                if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
                    this.style.display = "block";
                } else {
                    this.style.display = "none";
                }
            } )   
        };
        
        scrollToTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }

        
      }
  
      customElements.define("back-to-top", BackToTop);
    }
  })();